
import { CommonUtilitiesClass } from "@utilities/common_utilities_class";

const CommonUtilities = (function () {
  let instance: CommonUtilitiesClass;

  function createInstance() {
    const util = new CommonUtilitiesClass();
    return util;
  }

  return {
    getInstance: function () {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    }
  };
})();


export default CommonUtilities;
